<template>
  <main class="organization-profile">
    <pur-cont-modal ref="pcm"></pur-cont-modal>
    <div class="worker-header">
      <div class="tabs">
        <router-link :to="{name}" v-for="({name, title}, key) in navs" :key="key+'nav_org'" class="tabs-item" tag="div" active-class="active">
          {{ title }}
        </router-link>
        <div class="tabs-item" tag="div" active-class="active" @click="sendMessage">Чат</div>
      </div>
      <!--<div class="delivery-type-block" v-if="user_type == 2 && order.status == 0">
        <div class="tabs">
          <div class="tabs-item" v-for="item in delivery_types" :key="item.type+'dt'" :class="{active: item.type == delivery_type}" @click="delivery_type = item.type">
            {{ item.title }}
          </div>
        </div>
      </div>-->
      <div class="ml-3 mr-auto py-2" v-if="!loading">Статус: {{order.human_status}}</div>
<!--      <button class="edit">Редактировать</button>-->
<!--      <button class="edit">Сохранить без отправки</button>-->

<!--      <button class="add" @click="send()" v-if="order.status == 0 && order.contract">Отправить поставщику</button>-->
<!--      <button class="edit">Редактировать</button>-->
<!--      <button class="edit">Сохранить без отправки</button>-->
    </div>
    <div class="info">
      <div class="info-item">
        <div class="title">{{ user_type == 2 ? "Поставщик" : 'Клиент' }}</div>
        <div class="text" v-if="order.provider && user_type == 2">{{order.provider.name}} <img src="../../assets/icons/doc_success.svg" alt=""></div>
        <div class="text" v-if="order.purchaser && user_type == 1 && !order.dropshipping">{{order.purchaser.name}} <img src="../../assets/icons/doc_success.svg" alt=""></div>
        <div class="text" v-if="order.dropshipping && user_type == 1 && order.receiver_name">{{order.receiver_name}} <img src="../../assets/icons/doc_success.svg" alt=""></div>
      </div>
      <div class="info-item">
        <div class="title">ID заказа</div>
        <div class="text">{{order.id}}</div>
      </div>
      <div class="info-item">
        <div class="title">Ваш заказ</div>
        <div class="text" v-if="order.items">{{order.items.length}} {{declOfNum(order.items.length, ['товар', 'товара', 'товаров'])}} на сумму{{order.format_sum | currency}} руб. <span v-if="order.dropshipping && order.status != 0">(комиссия {{order.commission_sum}} руб.)</span></div>
      </div>
      <div class="info-item" v-if="order.contract_id">
        <div class="title">Мое юр. лицо</div>
        <div class="text">{{user_type == 2 ? order.order_contract.entity.company_name : order.order_contract.entity_provider.company_name}}</div>
      </div>
      <div class="info-item" v-if="order.contract_id">
        <div class="title">Юр. лицо партнера</div>
        <div class="text"><div class="text">{{user_type == 2 ? order.order_contract.entity_provider.company_name : order.order_contract.entity.company_name}}</div></div>
      </div>
      <div class="info-item" v-if="order.contract_id">
        <div class="title">Номер договора</div>
        <div class="text">{{order.order_contract.number}}</div>
      </div>
      <div class="info-item" v-if="order.dropshipping && order.status > 0">
        <div class="title">Телефон</div>
        <div class="text">{{order.receiver_phone}}</div>
      </div>
      <div class="info-item" v-if="order.dropshipping && order.status > 0 && user_type == 2">
        <div class="title">ФИО</div>
        <div class="text">{{order.receiver_name}}</div>
      </div>
      <div class="info-item" v-if="order.dropshipping && order.status > 0">
        <div class="title">Email</div>
        <div class="text">{{order.receiver_email}}</div>
      </div>
      <div class="info-item" style="width: 300px;" v-if="order.dropshipping && order.status == 0">
        <div class="title">ФИО получателя</div>
        <input v-model="receiver_name" class="receiver_name_input" placeholder="ФИО получаетеля" v-validate="'required'" name="receiver_name" data-vv-as="ФИО получаетеля" >
        <span class="text-danger text-sm">{{ errors.first('receiver_name') }}</span>
        <div class="title phone-title">Телефон получателя</div>
        <input v-model="receiver_phone" id="phone-field" class="receiver_name_input" placeholder="Телефон" v-validate="'required'" name="receiver_phone" data-vv-as="Телефон" >
        <span class="text-danger text-sm">{{ errors.first('receiver_phone') }}</span>
        <span class="text-danger text-sm" v-if="error_phone && !errors.first('receiver_phone')">{{ error_phone }}</span>
      </div>
      <div class="info-item" style="width: 232px;" v-if="order.dropshipping && order.status == 0">
        <div class="receiver-email-input">
            <div class="title phone-title">Email получателя</div>
            <input v-model="receiver_email" class="receiver_name_input" placeholder="Email" v-validate="'email'" name="receiver_email" data-vv-as="Email" >
            <span class="text-danger text-sm">{{ errors.first('receiver_email') }}</span>
        </div>
        <div class="title">Адрес доставки</div>
        <div class="text">{{receiver_address ? receiver_address : 'Не указано'}}</div>
      </div>
     <!-- <div class="info-item" v-if="order.status > 0">
        <div class="title">Договор</div>
        <div class="text">{{order.contract_id ? order.contract_id : ''}}</div>
      </div>-->
      <div class="info-item address-block" v-if="(user_type == 2 && order.status == 0) && !useCustomAddress && !order.dropshipping">
        <div class="title">Адрес доставки</div>
        <app-select :options="addresses" :value="address" v-validate="delivery_type == 1 ? 'required' : ''" name="address" @input="address = $event" placeholder="Адрес"/>
        <span class="text-danger text-sm address-error">{{ errors.first('address') }}</span>
      </div>
      <div class="type-delivery-block" v-if="order.status == 0 && !order.dropshipping">
        <div class="info-item">
          <div class="title">Способ доставки</div>
        </div>
        <app-select :options="delivery_types" :value="selected_delivery_type" label="title" name="delivery_type" @input="selectDeliveryType($event)" placeholder="Доставка"/>
        <button class="my-auto" style="width: 216px; position: absolute; top: 90px;" @click="calculationDelivery()" v-if="delivery_type == 2">
          Расчёт стоимости доставки
        </button>
        <div style="margin-top: 28px;">
          <!--<app-select :options="entities" v-validate="'required'" name="entity" label="company_name" data-vv-as="Юр лицо" :value="entity" @input="selectEntity($event)" placeholder="Юр лицо"/>
          <span class="text-danger text-sm">{{ errors.first('entity') }}</span>-->
          <!--<button class="btn-status" style="width: 200px;" @click="$refs.entityModal.open(order)">Договор</button>
          <span class="text-danger text-sm" v-if="error_contract">{{ error_contract }}</span>-->
        </div>
      </div>
      <div class="info-item" v-if="(user_type == 2 && order.status == 0) && useCustomAddress && delivery_type == 1 && !order.dropshipping">
        <div class="title">Адрес</div>
        <div class="text" v-if="useCustomAddress">{{getAddressString('custom')}}</div>
      </div>
      <button class="my-auto" style="width: 200px; position: absolute; left: 560px;" @click="$refs.adr.open({}, 'custom')" v-if="!useCustomAddress && order.status == 0 && delivery_type == 1 && !order.dropshipping">
        Указать другой адрес
      </button>
      <button class="my-auto" style="width: 200px; position: absolute; left: 576px; top: 0px;" @click="$refs.adr.open({}, 'custom')" v-if="!useCustomAddress && order.status == 0 && order.dropshipping">
        Адрес доставки
        <span class="text-danger text-sm address-error">{{ receiver_address_error }}</span>
      </button>
      <button class="my-auto" style="width: 150px;" @click="useCustomAddress = false; order.customAddress = undefined" v-if="useCustomAddress">
        Очистить
      </button>
      <div class="tk-container info-item" v-if="user_type == 2 && order.status == 0 && delivery_type == 2">
        <div class="title">Транспортная компания</div>
        <app-select :options="transport_companies" :value="transport_company" @input="selectCompany($event)" placeholder="Компания"/>
        <div>
          <div class="title">Терминал</div>
          <app-select :options="transport_terminals" :value="transport_terminal" @input="selectCompanyTerminal($event)" placeholder="Терминал"/>
        </div>
        <div>
          <div class="title">Адрес</div>
          <app-select :options="transport_addresses" :value="select_address" v-validate="delivery_type == 2 && !this.terminal && select_delivery_type2 != 'до адреса' ? 'required': ''" data-vv-as="отделение" name="select_address" @input="select_address = $event" placeholder="Адрес"/>
          <span class="text-danger text-sm address-error">{{ errors.first('select_address') }}</span>
        </div>
      </div>
      <!--<div class="info-item">
        <div class="title">Ваше Юр. лицо</div>
        <div class="text">ООО "Охота и рыбалка"</div>
      </div>-->
      <!--<div class="info-item">
        <div class="title">Вес, кг: <div class="other">7</div></div>
        <div class="title">Объем: <div class="other"> 3м3</div></div>
      </div>-->
    </div>
    <div class="info">
      <div class="info-item" v-if="order.status > 0">
        <div class="title">Тип доставки</div>
        <div class="text">{{deliveryTypeString(order.delivery_type)}}</div>
      </div>
      <div class="info-item" v-if="order.status > 0 && order.select_delivery_company">
        <div class="title">Название ТК</div>
        <div class="text">{{order.select_delivery_company}}</div>
      </div>
      <div class="info-item" v-if="order.status > 0">
        <div class="title">Адрес</div>
        <div class="text" v-if="order.dropshipping == 1 && order.receiver_address">{{order.receiver_address}}</div>
        <div class="text" v-if="order.delivery_type == 1 && order.address">{{order.address.human_address}}</div>
        <div class="text" v-if="order.delivery_type == 1 && order.human_address">{{order.human_address}}</div>
        <div class="text" v-if="order.delivery_type == 2 && order.transport_company">{{order.transport_company.human_address}}</div>
        <div class="text" v-if="order.delivery_type == 2 && order.terminal_address && order.select_delivery_company == 'Деловые линии'">Терминал № {{order.terminal_id}} ({{order.terminal_address}})</div>
        <div class="text" v-if="order.delivery_type == 2 && order.terminal_address && order.select_delivery_company == 'ПЭК'">Терминал {{order.terminal_address}}</div>
        <div class="text" v-if="order.delivery_type == 2 && order.select_delivery_type2 == 'до адреса' && order.address.human_address">{{order.address.human_address}}</div>
        <div class="text" v-if="order.delivery_type == 3">Самовывоз</div>
      </div>
      <div class="info-item" v-if="order.status > 0 && order.invoice_number">
        <div class="title">Номер заявки в ТК</div>
        <div class="text">{{order.invoice_number}}</div>
      </div>
      <div class="info-item" v-if="order.status > 0 && order.invoice_number && invoice_info.delivery_status">
        <div class="title">Статус доставки</div>
        <div class="text">{{invoice_info.delivery_status}}</div>
      </div>
    </div>
    <div class="info" v-if="order.status > 0">
      <div class="info-item">
        <div class="title">Фактический вес</div>
        <div class="text" v-if="invoice_info.weight">{{invoice_info.weight}}</div>
      </div>
      <div class="info-item">
        <div class="title">Фактический объем</div>
        <div class="text" v-if="invoice_info.vol">{{invoice_info.vol}}</div>
      </div>
      <div class="info-item">
        <div class="title">Фактическая сумма</div>
        <div class="text" v-if="invoice_info.sum">{{invoice_info.sum}}</div>
      </div>
      <div class="info-item">
        <div class="title">Дата отгрузки</div>
        <div class="text" v-if="invoice_info.date_from">{{invoice_info.date_from}}</div>
      </div>
      <div class="info-item">
        <div class="title">Дата поступления</div>
        <div class="text" v-if="invoice_info.date_to">{{invoice_info.date_to}}</div>
      </div>
      <div class="info-item">
        <div class="title">Состояние счета</div>
        <div class="text" v-if="invoice_info.paid">{{invoice_info.paid}}</div>
      </div>
    </div>
    <div style="margin-bottom: -50px;" v-if="invoice_info.order || invoice_info.bill">
      <button v-if="invoice_info.order" class="add ml-auto" style="width: 260px; display: inline-block; margin-left: 20px !important;" @click="$refs.delInvoice.open(invoice_info.order)">Накладная</button>
      <button v-if="invoice_info.bill" class="add ml-auto" style="width: 260px; display: inline-block; margin-left: 20px !important;" @click="$refs.delInvoice.open(invoice_info.bill)">Счет</button>
    </div>
    <loading-container :loading="loading" height="99">
      <table style="margin-top: 90px;">
        <tr>
          <th>Фото</th>
          <th>Артикул</th>
          <th>Наименование товара</th>
          <!--<th>Тип</th>-->
          <th>Цвет</th>
          <th>Размер</th>
          <th>Бренд</th>
          <th width="120px">Штук в уп-ке</th>
          <th width="120px">Цена за шт. руб.</th>
          <!--<th>-&#45;&#45;</th>-->
<!--          <th>Категория</th>-->
          <th>
            Тип товара
          </th>
          <th>Остаток <br>поставщика</th>
          <th width="100px" style="word-wrap: unset">Кол-во</th>
          <th>Сумма, руб.</th>
          <th v-if="order.dropshipping && order.status != 0">Комиссия, %</th>
          <th v-if="order.dropshipping && order.status != 0">Сумма комиссии</th>
          <th style="padding: 0; width: 48px; background-color: white;"></th>
        </tr>
        <tr v-for="(item, idx) in items" :key="idx" class="tc">
          <td class="ta-center"><img v-if="item.product.image != null" :src="item.product.image != null ? item.product.image.image : ''" alt=""></td>
          <td>{{item.product.article}}</td>
          <td>
            <a id="link" @click="openInTab(item.product_id)">
              {{item.product.name}}
            </a>
          </td>
<!--          <td>{{item.product.labels.join(', ')}}</td>-->
          <!--<td>{{ item.product.main_attr != null && item.product.main_attr.type ?  item.product.main_attr.type : '' }}</td>-->
          <td>{{ item.product.main_attr != null && item.product.main_attr.color ? item.product.main_attr.color : '' }}</td>
          <td>{{ item.product.main_attr != null && item.product.main_attr.size ? item.product.main_attr.size : '' }}</td>
          <td>{{ item.product.main_attr != null && item.product.main_attr.brand ? item.product.main_attr.brand : '' }}</td>
          <td class="text-right">{{item.product.main_attr.count_in_pkg}}</td>
          <td style="color: #2CB181" class="text-right">{{item.product.price_opt | currency}}</td>
<!--          <td>{{item.product.category.name}}</td>-->
          <td>
            <product-labels :labels="item.product.labels" />
          </td>
          <td class="text-right">{{item.product.quantity}}</td>
          <td>
              <app-chevron-counter v-if="order.status < 3" v-model="item.count" @keyup="changeCount(idx)"/>
              <span v-if="order.status > 2">{{item.count}}</span>
          </td>
          <td width="110px" class="text-right">{{item.product.price_opt * item.count | currency}}</td>
          <th v-if="order.dropshipping && order.status != 0">{{item.commission}}</th>
          <th v-if="order.dropshipping && order.status != 0">{{item.commission_sum}}</th>
          <td><img v-if="order.status < 3" @click="deleteProduct(item.product_id, idx)" class="hover_btn trash" src="../../assets/icons/delete.svg" alt=""></td>
        </tr>
      </table>
      <span v-if="order.status == 0">
        <br>
        Комментарий:
        <br>
        <textarea v-model="comment" name="" id="" cols="30" rows="10"></textarea>
      </span>
      <span v-if="order.status > 0">
        <br>
        Комментарий:
        <br>
        {{order.comment}}
      </span>
      <div v-if="user_type == 1" style="position: absolute; right: 27px;">
        <br>
        <button class="btn-status ml-auto" style="width: 300px; display: inline-block;" v-if="order.status == 1 || order.status == 2" @click="$refs.entityModal.open(order)">Отправить в 1С на оформление</button>
        <button class="btn-status ml-auto" style="width: 300px; display: inline-block;" v-if="order.status == 4" @click="changeStatus(6)">Сменить статус на отправлено</button>
        <button class="add ml-auto" style="width: 260px; display: inline-block; margin-left: 20px !important;" @click="exportExcel()" v-if="user_type == 1">Экспорт в excel</button>
        <br><br>
      </div>
      <div v-if="user_type == 2 && order.status >= 1" style="position: absolute; right: 27px;">
        <br>
        <button class="add ml-auto" style="width: 260px; display: inline-block; margin-left: 20px !important;" @click="exportExcel()">Экспорт в excel</button>
        <button v-if="invoice_info.order" class="add ml-auto" style="width: 260px; display: inline-block; margin-left: 20px !important;" @click="$refs.delInvoice.open(invoice_info.order)">Накладная</button>
        <button v-if="invoice_info.bill" class="add ml-auto" style="width: 260px; display: inline-block; margin-left: 20px !important;" @click="$refs.delInvoice.open(invoice_info.bill)">Счет</button>
        <br>
        <br>
      </div>
      <template v-if="order.status < 1">
        <div v-if="!order.dropshipping" class="label-search">Здесь можно добавить товары к заказу от текущего поставщика:</div>
        <div v-if="!order.dropshipping" class="search">
          <input autocomplete="off" name="search" v-model="search" placeholder="Поиск" @keyup="searchProducts()">
          <img class="hover_btn" src="@/assets/img/worker/search.svg" alt="">
        </div>
        <div class="result" style="position: relative;">
          <div class="title" v-if="search && !order.dropshipping">Найдено <div class="green">{{result.length}} {{declOfNum(result.length, ['позиция', 'позиции', 'позиций'])}}</div> у поставщика "{{order.provider.name}}"</div>
          <div v-if="!order.dropshipping" class="table flex row tab_overflow">
            <table class="col-12">
              <tr>
                <th>Наименование</th>
                <th>Артикул</th>
                <!--<th>Поставщик</th>-->
                <th width="120px">Цена, руб.</th>
                <th>Остаток</th>
                <th>
                  <app-checkbox/>
                </th>
              </tr>
              <tr v-for="(item, idx) in result" :key="idx" class="tc">
                <td>{{item.name}}</td>
                <td>{{item.article}}</td>
                <!--<td>{{result.supplier}}</td>-->
                <td class="text-right">{{item.price_rcc | currency}}</td>
                <td style="color: #2CB181" class="text-right">{{item.quantity}}</td>
                <td width="40px">
                  <app-checkbox v-model="item.checked"/>
                </td>
              </tr>
            </table>

          </div>
          <br v-if="order.dropshipping">
          <div style="position: absolute; right: 27px; top: -80px;">
            <button class="add ml-auto" style="width: 260px; display: inline-block; margin-left: 20px !important;" @click="sendOrderModal()" v-if="order.status == 0 && order.contract">Отправить поставщику</button>
            <button class="add ml-auto" style="width: 260px; display: inline-block; margin-left: 20px !important;" @click="$refs.pcm.open(order.provider_id)" v-if="order.status == 0 && !order.contract && can('page.partners')">Заключить договор</button>
            <button class="add ml-auto" style="width: 260px; display: inline-block; margin-left: 20px !important;" @click="exportExcel()">Экспорт в excel</button>
            <button class="add ml-auto" style="width: 260px; display: inline-block; margin-left: 20px !important;" v-if="user_type == 1">Согласовать</button>
          </div>

          <button class="add mt-4" @click="addToOrder()" v-if="!order.dropshipping">Добавить к заказу</button>
        </div>
      </template>


    </loading-container>
    <adress-modal  ref="adr" title="Адрес доставки" @save="adresSave"/>
    <provider-entity-modal @select_contract="select_contract = $event" @select_counteragent="select_counteragent = $event" @clear="clearDeliveryType()" @send="send()" ref="entityModal"/>
    <delivery-info-modal @select_delivery_company="select_delivery_company = $event" @select_delivery_type="select_delivery_type = $event" @select_delivery_type2="select_delivery_type2 = $event" @select_terminal="terminal = $event" @receiver_info="receiver_info = $event" @continue="sendModal()" ref="delInfo"/>
    <delivery-invoice-modal ref="delInvoice"/>
  </main>
</template>

<script>
import LoadingContainer from "@/components/loading-container";
import AppChevronCounter from "@/components/app-chevron-counter";
import AppSelect from "@/components/app-select";
import AppCheckbox from "@/components/app-checkbox";
import AdressModal from "@/components/modals/adress-modal";
import PurContModal from "@/components/modals/purchaser-contract-modal";
import ProviderEntityModal from "@/components/modals/provider-entity-modal";
import DeliveryInfoModal from "@/components/modals/delivery-info-modal";
import DeliveryInvoiceModal from "@/components/modals/delivery-invoice-modal";
import Inputmask from 'inputmask'
import ProductLabels from "@/components/product-labels";

export default {
  name: "purchase-edit",
  data: function () {
    return {
      search: '',
      menus:[],
      loading: true,
      contracts: [],
      type: '',
      no_active: false,
      useCustomAddress: false,
      select_contract: '',
      error_contract: '',
      order:[],
      items:[],
      result:[],
      navs: [
        {
          title: 'Общая информация',
          name: 'opured',
        },
        // {
        //   title: 'Чат',
        //   name: 'oprof',
        // },

      ],
      company_id: null,
      address: '',
      addresses: [],
      user_type: 0,
      delivery_type: 1,
      delivery_types: [
        {
          title: 'Силами поставщика',
          type: 1
        },
        {
          title: 'Транспортная компания',
          type: 2
        },
        {
          title: 'Самовывоз',
          type: 3
        }
      ],
      selected_delivery_type: {
        title: 'Силами поставщика',
        type: 1
      },
      transport_companies: [],
      transport_company: '',
      transport_terminals: [],
      transport_terminal: '',
      transport_addresses: [],
      select_address: '',
      entities: [],
      entity: '',
      receiver_address: '',
      receiver_name: '',
      receiver_address_error: '',
      receiver_phone: '',
      error_phone: '',
      receiver_email: '',
      url: '',
      select_delivery_company: '',
      select_delivery_type: '',
      select_delivery_type2: '',
      terminal: '',
      receiver_info: '',
      delivery_city: '',
      invoice_info: [],
      delline_session: false,
      pec_session: false,
      comment: '',
      select_counteragent: ''
    }
  },
  mounted() {
    this.url = `${process.env.VUE_APP_BACKEND_URL}/export-order?order_id=${this.$route.params.id}&token=${localStorage.getItem('token')}`
    this.getOrder();
    this.user_type = localStorage.getItem('type');

    if (this.user_type == 2) {
      this.getAddresses();
      this.getCompanies();
      /*this.getEntities();*/
    }
  },
  methods: {
    openInTab(id) {
      const routeData = this.$router.resolve({name: 'item', params: {id: id}});
      window.open(routeData.href, '_blank');
    },
    exportExcel() {
      location.href = this.url;
    },
    deliveryTypeString(type) {
      for (let key in this.delivery_types) {
        if (type == this.delivery_types[key].type) {
          return this.delivery_types[key].title;
        }
      }
    },
    sendModal() {
      this.$refs.entityModal.open(this.order, this.select_delivery_company, this.select_delivery_type, this.receiver_info, this.delline_session, this.select_delivery_company);
    },
    clearDeliveryType() {
      this.select_delivery_company = '';
      this.select_delivery_type = '';
      this.terminal = '';
    },
    calculationDelivery(tk=null) {
      if (!this.address) {
        this.errors.add({
          field: 'address',
          msg: 'Не выбран адрес'
        });
        this.$toast.error('Не выбран адрес!');
      } else {
        this.$refs.delInfo.open(this.address, this.order, this.delline_session, this.pec_session, tk)
      }
    },
    sendOrderModal() {
      this.$validator.validateAll()
          .then(success=>{
            if(success){
              this.$refs.entityModal.open(this.order, null, null);
            } else {
              if (this.errors.first('address')) {
                this.$toast.error('Не выбран адрес!');
              }
            }
          })
    },
    adresSave(payload){
      console.log(payload);
      if (!this.order.dropshipping) {
        this.$http.post( '/add-company-address', {
          token: localStorage.getItem('token'),
          country: payload.custom_address_country,
          city: payload.custom_address_city,
          street: payload.custom_address_street,
          house: payload.custom_address_house,
          flat: payload.custom_address_flat,
          address_index: payload.custom_index,
          corps: payload.custom_address_corps,
          info: payload.custom_info
        }).then(({data}) => {
          if (data.success) {
            this.$toast.success('Адрес успешно добавлен!');
            this.getAddresses()
          }
        })
          .catch((error) => {
            console.log(error)
          })
      } else {
        this.receiver_address = this.getDeliveryAddressString(payload);
      }

    },
    getDeliveryAddressString(payload, type = 'custom'){
      if(payload[type +'_address_country'] != null && payload[type +'_address_city'] != null && payload[type +'_address_house'] != null) {
        return `${payload[type + '_index'] ? payload[type + '_index'] + ', ' : ''}${payload[type + '_address_country']}, ${payload[type + '_address_city']}, ${payload[type + '_address_region'] ? payload[type + '_address_region'] : ''},${payload[type + '_address_street']}, д.${payload[type + '_address_house']}${payload[type + '_address_corps'] ? (', к.'+payload[type + '_address_corps']) : ''}${payload[type + '_address_flat'] ? ', офис '+payload[type + '_address_flat'] : ''}`
      }
    },
    sendMessage() {
      if (localStorage.getItem('token')) {
        this.$http.post('/create-chat', {
          token: localStorage.getItem('token'),
          id: this.company_id,
        }).then(({data}) => {
          if (data.success) {
            this.$router.push('/chat?company=' + this.company_id);
          }
        })
            .catch((error) => {
              console.log(error)
            })
      }
    },
    getOrder(){
      if (localStorage.getItem('token')) {
        this.loading = true;
        this.$http.post('/get-order', {
          token: localStorage.getItem('token'),
          id: this.$route.params.id
        }).then(({data})=> {
          if (data.order) {
            if (data.order.status > 0) {
              this.getInvoiceinfo();
            }
            if(localStorage.getItem('type') == 2){
              this.company_id = data.order.provider.id
            }else{
              this.company_id = data.order.purchaser.id
            }

            if (data.session_id) {
              this.delline_session = true;
            }

            if (data.pec_session) {
              this.pec_session = true;
            }

            this.order = data.order;
            this.items = data.order.items;
            let city = data.order.terminal_address.split(',');
            this.delivery_city = city[0];

            if (this.order.dropshipping && this.order.import_xml) {
              for (let key in this.items) {
                this.items[key].product.price_opt = this.items[key].price;
              }
            }
            if (this.order.dropshipping) {
              if (this.user_type == 1) {
                this.$route.meta.back1 = 'drprord';
              } else {
                this.$route.meta.back2 = 'dropur';
              }
            } else {
              if (this.user_type == 1) {
                this.$route.meta.back1 = 'prord';
              } else {
                this.$route.meta.back2 = 'opur';
              }
            }
            var im = new Inputmask("+7 (999) 999 99 99");
            setTimeout(()=>{
              im.mask(document.getElementById('phone-field'));
            },1000)

          }
        })
        .catch((error) => {
            console.log(error)
        })
        .finally(()=> this.loading = false)
      }
    },
    getInvoiceinfo(){
      if (localStorage.getItem('token')) {
        this.$http.post('/order-invoice-info', {
          token: localStorage.getItem('token'),
          id: this.$route.params.id
        }).then(({data})=> {
          if (data.info) {
            this.invoice_info = data.info;
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    declOfNum(n, text_forms) {
      n = Math.abs(n) % 100; var n1 = n % 10;
      if (n > 10 && n < 20) { return text_forms[2]; }
      if (n1 > 1 && n1 < 5) { return text_forms[1]; }
      if (n1 == 1) { return text_forms[0]; }
      return text_forms[2];
    },
    deleteProduct(id, key) {
      this.$http.post('/delete-order-item', {
        token: localStorage.getItem('token'),
        product_id: id,
        id: this.$route.params.id
      }).then(({data}) => {
        if (data.order) {
          this.order = data.order;
          this.items.splice(key, 1);
          this.$toast.success('Товар успешно удален!');
        }

        if (data.active){
          this.$router.push('/purchaser-orders');
        }
      })
      .catch((error) => {
          console.log(error)
      })
    },
    changeCount(key) {
      if (this.items[key].count >= 1) {

        this.$http.post ( '/change-count-order-item', {
          token: localStorage.getItem ( 'token' ),
          product_id: this.items[key].product_id,
          count: this.items[key].count,
          id: this.$route.params.id
        } )
            .then (({ data }) => {
              if(data.order) {
                this.order = data.order;
              }
            } )
            .catch ((e) => {
              console.log (e)
            })
      }
    },
    searchProducts() {
      if (this.search.length > 1) {
        this.$http.post('/search-order-products', {
          token: localStorage.getItem('token'),
          search: this.search,
          id: this.$route.params.id
        }).then(({data}) => {
          if (data.items) {
            for (let key in data.items) {
              data.items[key].checked = false;
            }
            this.result = data.items;
          }
        })
        .catch((error) => {
            console.log(error)
        })
      }
    },
    addToOrder() {
      let products = [];

      for (let key in this.result) {
        if (this.result[key].checked) {
          products.push(this.result[key].id);
        }
      }

      if (products.length) {
        this.$http.post('/add-order-product', {
          token: localStorage.getItem('token'),
          products: products,
          id: this.$route.params.id
        }).then(({data}) => {
          if (data.order) {
            this.order = data.order;
            this.items = data.order.items;
            this.$toast.success('Товар успешно добавлен!');
          }
        })
        .catch((error) => {
            console.log(error)
        })
      }else {
          this.$toast.error('Выберите товар!');
      }
    },
    send() {
      this.receiver_address_error = '';
      if (this.order.dropshipping && !this.receiver_address) {
        this.receiver_address_error = 'Укажите адрес';
        return false;
      }

      if (this.order.dropshipping) {
        this.error_phone = '';

        if (this.receiver_phone.indexOf('_') !== -1 || !this.receiver_phone) {
          this.error_phone = 'Поле телефон обязательно к заполнению.';
          return false;
        }
      }

      if (this.select_contract) {
        this.error_contract = '';
        this.$validator.validateAll()
                .then(success=>{
          if(success){
            this.$http.post('/send-order', {
              token: localStorage.getItem('token'),
              id: this.$route.params.id,
              address_id: this.useCustomAddress && this.delivery_type == 1 ? '' : this.address.id,
              address: this.useCustomAddress ? this.order.customAddress: '',
              delivery_type: this.delivery_type,
              contract: this.select_contract,
              company_id: this.delivery_type == 2 ? this.select_address.id : '',
              receiver_name: this.receiver_name,
              receiver_address: this.receiver_address,
              receiver_phone: this.receiver_phone,
              receiver_email: this.receiver_email,
              select_delivery_company: this.select_delivery_company,
              select_delivery_type: this.select_delivery_type,
              terminal_address: this.terminal ? this.terminal.address : '',
              terminal_id: this.terminal ? this.terminal.id : '',
              receiver_info: this.receiver_info,
              comment: this.comment,
              select_delivery_type2: this.select_delivery_type2,
              counteragent: this.select_counteragent
            }).then(({data}) => {
              if (data.success) {
                this.order.status = 1;
                this.order.address = {};
                this.order.address.human_address = this.address.label;
                if (data.tk) {
                  this.$toast.success('Заказ отправлен в транспортную компанию!');
                }
                this.$toast.success('Заказ отправлен поставщику!');
                if (this.order.dropshipping) {
                    this.$router.push('/dropshipping-purchaser-orders')
                } else {
                    this.$router.push('/purchaser-orders')
                }

              }
            })
            .catch((error) => {
                console.log(error)
            })
          }
        })
      } else {
        this.error_contract = 'Выберите договор';
      }

    },
    selectDeliveryType(val){
      this.selected_delivery_type = val;
      this.delivery_type = val.type;
    },
    selectEntity(val) {
      this.entity = val;
    },
    /*xml () {
      if (localStorage.getItem('token')) {
        this.$http.post('/order-xml', {
          token: localStorage.getItem('token'),
          id: this.$route.params.id
        }).then(({data}) => {
          if (data.success) {
            this.$toast.success('Заказ отправлен в 1С');
          }
        })
        .catch((error) => {
            console.log(error)
        })
      }
    },*/
    changeStatus(val) {
      if (localStorage.getItem('token')) {
        this.$http.post('/change-order-status', {
          token: localStorage.getItem('token'),
          id: this.$route.params.id,
          status: val
        }).then(({data}) => {
          if (data.success) {
            this.$toast.success('Статус успешно изменен!');
          }
        })
        .catch((error) => {
            console.log(error)
        })
      }
    },
    getAddresses() {
      this.addresses = [];
      this.$http.post('/get-company', {
        token: localStorage.getItem('token'),
      }).then(({data}) => {
        if (data.company) {
          for (let key in data.company.addresses) {
            if (data.company.addresses[key].active) {
              this.addresses.push({
                id: data.company.addresses[key].id,
                label: data.company.addresses[key].human_address
              });
            }

          }
        }
      })
      .catch((error) => {
          console.log(error)
      })
    },
    getEntities() {
      this.$http.post('/get-entities', {
        token: localStorage.getItem('token'),
      }).then(({data}) => {
        if (data.entities) {
          this.entities = data.entities;
        }
      })
      .catch((error) => {
          console.log(error)
      })
    },
    getCompanies() {
      this.$http.post('/get-transport-companies', {
        token: localStorage.getItem('token'),
      }).then(({data}) => {
        if (data.transport_companies) {
          for (let key in data.transport_companies) {
            this.transport_companies.push({
              label: data.transport_companies[key].name
            });
          }
        }
      })
      .catch((error) => {
          console.log(error)
      })
    },
    selectCompany(val) {
      this.transport_company = val;
      this.transport_terminals = [];
      this.transport_addresses = [];
      this.select_address = '';
      this.transport_terminal = '';
      /*if (val.label == 'Деловые линии') {
        this.calculationDelivery('Деловые линии')
      }*/
      this.$http.post('/get-transport-terminals', {
        token: localStorage.getItem('token'),
        company: this.transport_company.label
      }).then(({data}) => {
        if (data.transport_companies) {
          for (let key in data.transport_companies) {
            this.transport_terminals.push({
              label: data.transport_companies[key].terminal
            });
          }
        }
      })
      .catch((error) => {
          console.log(error)
      })
    },
    selectCompanyTerminal(val) {
      this.transport_terminal = val;
      this.transport_addresses = [];
      this.select_address = '';
      this.$http.post('/get-transport-addresses', {
        token: localStorage.getItem('token'),
        company: this.transport_company.label,
        terminal: this.transport_terminal.label
      }).then(({data}) => {
        if (data.transport_companies) {
          for (let key in data.transport_companies) {
            this.transport_addresses.push({
              id: data.transport_companies[key].id,
              label: data.transport_companies[key].address
            });
          }

          if (data.transport_companies.length == 1) {
            this.select_address = {
              id: data.transport_companies[0].id,
              label: data.transport_companies[0].address
            };
          }
        }
      })
      .catch((error) => {
          console.log(error)
      })
    },
    clearCustomArray(){
      this.order = Object.fromEntries(Object.entries(this.order).remove('customAddress'))
    },
    getAddressString(type = 'legal'){
      if(this.entity[type +'_address_country'] != null && this.entity[type +'_address_city'] != null && this.entity[type +'_address_house'] != null) {
        return `${this.entity[type + '_index'] ? this.entity[type + '_index'] + ', ' : ''}${this.entity[type + '_address_country']}, ${this.entity[type + '_address_city']}, ${this.entity[type + '_address_street']}, ${this.entity[type + '_address_house']}${this.entity[type + '_address_corps'] ? (', '+this.entity[type + '_address_corps']) : ''}${this.entity[type + '_address_flat'] ? ','+this.entity[type + '_address_flat'] : ''}`
      }else{
        return 'Не указано'
      }
    },
  },
  components: {
    AdressModal,
    AppCheckbox,
    AppChevronCounter,
    LoadingContainer,
    AppSelect,
    PurContModal,
    ProviderEntityModal,
    DeliveryInfoModal,
    DeliveryInvoiceModal,
    ProductLabels
  }
}
</script>

<style>
  .v-select {
    margin-bottom: 4px !important;
  }
</style>
<style scoped lang="scss">
textarea{
  width: 600px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding: 10px;
  height: 50px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 107px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}

.receiver-email-input {
    margin-top: -16px;
    margin-bottom: 24px;
}
.phone-title {
  margin-top: 10px;
}
.receiver_name_input {
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
  height: 40px;
  padding: 0 40px 0 15px;
  outline: none;
  font-size: 12px;
}
#link {
  cursor: pointer;
}
.worker-header {
  min-width: 1300px !important;
}

.tk-container {
  position: absolute;
  top: -19px;
  left: 1110px;
  /*min-width: 254px;*/
  width: 430px !important;
}
.ta-center {
  text-align: center !important;
  vertical-align: middle !important;
}

.btn-status {
  width: 24%;
}

.type-delivery-block {
  position: absolute;
  left: 880px;
  top: -17px;
  width: 212px;
}
/*.delivery-type-block {
  position: absolute;
  left: 942px;
}*/

.tab_overflow{
  overflow: auto;
  max-height: 543px;
  width:60%;
}
.address-block {
  width: 300px !important;
  position: absolute;
  top: -17px;
  left: 560px;
}

.address-error {
  position: absolute;
  bottom: -14px;
  font-size: 13px;
}
.result{
  .title{
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .green{
      color: #2CB181;
      margin: 0 5px;
    }
  }
  .row{
    margin: 0;
  }
}
.label-search{
  margin-top: 20px;
  font-size: 14px;
}
.search {
  margin-top: 10px;
  position: relative;
  width: 20%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 15px;

  > input {
    border: 1px solid #EEF0F3;
    box-sizing: border-box;
    border-radius: 4px;
    width: 100%;
    height: 40px;
    padding: 0 40px 0 15px;
    outline: none;
    &:focus{
      border: 1px solid #2CB181;
    }
  }

  > img {
    position: absolute;
    right: 15px;
    bottom: 50%;
    transform: translateY(50%);
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
}
table tr:nth-child(even) {
  background: unset;
}
table td{
  &.done{
    color: #2CB181;
  }
  &.wait{
    color: #F39220;
  }
  img{
    cursor: pointer;
    margin: auto;
    max-width: 40px;
    max-height: 40px;
  }
}
table tr{
  border-bottom: 1px solid #a3a3a3 ;
  .trash{
    display: none;
  }
  &:hover{
    .trash{
      display: unset;
    }
  }
}
.tc:hover .dots, .tc:hover, .tc:hover .chevron-counter {
  opacity: 1;
  background: #F9F9FB;

}
.search-block {
  position: absolute;
  top: 0px;
  right: 32px;
}
.organization-profile {
  position: relative;
}
.dots{
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  opacity: 0;
  width: 20px;
  transition: opacity .3s, background-color .7s;

  &.active{
    opacity: 1;
  }
}
main {
    margin-top: 32px;
    margin-left: 32px;
}
.organization-profile {
  width: 100%;
  padding: 0 30px;

  .active {
    color: #2CB181;
    font-weight: 500;
  }
}
.info{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 35px;
  margin-top: 30px;
  &-item{
    width: max-content;
    margin-right: 40px;
    .title{
      display: flex;
      align-items: center;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      color: #7A818F;
      margin-bottom: 5px;
      .other{
        color: black;
        margin-left: 5px;
      }
    }
    .text{
      display: flex;
      align-items: center;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      color: #2D3137;
      img{
        margin-left: 5px;
      }
    }
  }
}
button{
  border: none;
  height: 40px;
  width: 20%;
  background: #2CB181;
  border-radius: 4px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  &.edit{
    border: 1px solid #B6BCC8;
    background: initial;
    font-weight: 500;
    font-size: 14px;
    height: 40px;
    outline: none;
    border-radius: 4px;
    width: 20%;
    margin: 0 0 0 8px;
    color: #7A818F;
  }
  &.add {
    background: #2CB181;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    height: 40px;
    border: none;
    outline: none;
    border-radius: 4px;
    width: 20%;
    margin: 0 0 0 8px;
  }
}
.worker {
  position: relative !important;

  &-header {
    height: 40px;
    margin-bottom: 18px;
    display: flex;
    justify-content: space-between;

    .tabs{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      display: flex;
      justify-content: center;
      width: max-content;
      background-color: white;
      border-radius: 4px;
      border: 1px solid #EEF0F3;

      &-item {
        margin: 0;
        position: relative;
        cursor: pointer;
        padding: 10px 15px;
        margin: 2px 0 2px 0;
        color: #7A818F;
      }
      &-item:first-child{
        margin-left: 2px;
      }
      &-item:last-child{
        margin-right: 2px;
      }
      &-item.active {
        background: #EEF0F3;
        border-radius: 4px;
      }
      &-item:after{
        border-left: 1px solid #EEF0F3;
        content: " ";
        position: absolute;
        top: 35%;
        right: 0;
        height: 30%;
        margin-top: auto;
        margin-bottom: auto;
      }
      &-item:last-child:after{
        border-left: unset;
      }
    }
  }


}
</style>
